import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { FiltersChip } from "components";
import { useReportsActions, useReportsFiltersSelector } from "store";

import { FiltersDrawer } from "../Filters-drawer/FiltersDrawer";

import "./FiltersView.styles.scss";

interface IFiltersViewProps {
  limitTags?: number;
  title?: string;
}

export const FiltersView: React.FC<IFiltersViewProps> = ({ limitTags = 5, title = "Filter" }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const filters = useReportsFiltersSelector();
  const { setQueriesAction } = useReportsActions();

  const filtersNumber = Object.keys(filters).length;

  const removeFilter = (filter: string): void => {
    const filtersCopy = { ...filters };
    delete filtersCopy[filter];
    setQueriesAction({ filters: filtersCopy });
  };

  const removeFilterItem = ({ field, option }: { field: string; option: string }): void => {
    const filtersCopy = { ...filters };
    filtersCopy[field] = filtersCopy[field].filter((value) => value !== option);

    if (!filtersCopy[field].length) {
      return removeFilter(field);
    }
    setQueriesAction({ filters: filtersCopy });
  };

  // const handleChangeCurrency = (value: CurrencyType) => {
  //   setQueriesAction({ currency: value });
  // };

  return (
    <div className="filters-view">
      <div className="filters-view__box">
        <div className="filters-view__box-trigger" onClick={() => setIsDrawerOpen(true)}>
          <FilterAltIcon
            sx={{
              width: "18px",
              height: "18px"
            }}
          />
          <span>{title}</span>
        </div>
        <div className="items">
          {Object.keys(filters)
            .slice(0 - limitTags)
            .map((item: string) => (
              <FiltersChip
                key={item}
                field={item}
                options={filters[item] as string[]} // TS issue
                removeFieldOption={removeFilterItem}
                onRemove={removeFilter}
              />
            ))}
        </div>
        {filtersNumber > limitTags && <div className="filters-view__box-collapse">+{filtersNumber - limitTags}</div>}
        {!!Object.keys(filters).length && (
          <div onClick={() => setQueriesAction({ filters: {} })} className="filters-view__box-clear">
            <CloseIcon className="icon" />
            <span>Clear All Filters</span>
          </div>
        )}
        <FiltersDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
      </div>
    </div>
  );
};
